import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BookOpen, LogIn, UserPlus, X } from 'lucide-react';

/**
 * Modal shown when a guest tries to read protected content.
 * Prompts to sign in or sign up; passes current location (or returnPath) for redirect after login.
 */
const LoginPromptModal = ({ isOpen, onClose, title, message, returnPath }) => {
  const location = useLocation();
  const from = returnPath
    ? { pathname: returnPath, search: '' }
    : { pathname: location.pathname, search: location.search };

  if (!isOpen) return null;

  return (
    <div className="login-prompt-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="login-prompt-title">
      <div className="login-prompt-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="login-prompt-close"
          onClick={onClose}
          aria-label="Close"
        >
          <X size={22} />
        </button>
        <div className="login-prompt-icon">
          <BookOpen size={40} />
        </div>
        <h2 id="login-prompt-title" className="login-prompt-title">
          {title || 'Sign in to continue reading'}
        </h2>
        <p className="login-prompt-message">
          {message || 'Create a free account or sign in to access this content and save your progress.'}
        </p>
        <div className="login-prompt-actions">
          <Link
            to="/login"
            state={{ from }}
            className="btn btn-primary login-prompt-btn"
            onClick={onClose}
          >
            <LogIn size={18} />
            Sign in
          </Link>
          <Link
            to="/signup"
            state={{ from }}
            className="btn btn-outline login-prompt-btn"
            onClick={onClose}
          >
            <UserPlus size={18} />
            Create account
          </Link>
        </div>
        <button type="button" className="login-prompt-skip" onClick={onClose}>
          Maybe later
        </button>
      </div>
    </div>
  );
};

export default LoginPromptModal;
